// import { Dispatch, Action } from 'redux'
// import { createSubmitAction } from 'actionCreators/submit/Submit/createSubmitAction'
// import { SUBMIT_DELETE_TASK_TAG } from 'actions'

import {
  // FullImageWidgetConnectedProps,
  FullImageWidgetMapDispatchReturnType,
} from './types'

export const FullImageWidgetMapDispatch = (
  // dispatch: Dispatch<Action>,
  // props: FullImageWidgetConnectedProps,
): FullImageWidgetMapDispatchReturnType => {
  return {
  }
}
